import { Stack, Typography } from "@mui/material";
import React from "react";
import {
  PieChart,
  Pie,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from "recharts";

function CustomPieChart({ title, chartData, colors, borderRight = 0 }) {
  const borderRadius = 0;
  // console.log(chartData)
  return (
    <Stack
      sx={{
        width: "100%",
        borderRadius: borderRadius,
        border: 0,
        borderColor: "lightgray",
        borderRight: borderRight,
      }}
    >
      <Typography
        align="center"
        sx={{
          py: 0.5,
          fontSize: 14,
          fontWeight: "bold",
          color: "secondary.main",
        }}
      >
        {title}
      </Typography>
      <ResponsiveContainer width="100%" height={200}>
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#8884d8"
            label={(entry) => `${entry.name}: ${entry.value}`} // Show labels for slices
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))}
          </Pie>
          <Tooltip />
          {/* <Legend wrapperStyle={{ fontSize: 14 }} /> */}
        </PieChart>
      </ResponsiveContainer>
    </Stack>
  );
}

export default CustomPieChart;
